import { render, staticRenderFns } from "./assurance-groupe-list.html?vue&type=template&id=265daee2&scoped=true&external"
import script from "./assurance-groupe-list.js?vue&type=script&lang=js&external"
export * from "./assurance-groupe-list.js?vue&type=script&lang=js&external"
import style0 from "./assurance-groupe-list.scss?vue&type=style&index=0&id=265daee2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265daee2",
  null
  
)

export default component.exports